import { render } from "./appSetup.vue?vue&type=template&id=46ccac41&scoped=true"
import script from "./appSetup.vue?vue&type=script&lang=js"
export * from "./appSetup.vue?vue&type=script&lang=js"

import "./appSetup.vue?vue&type=style&index=0&id=46ccac41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ccac41"]])

export default __exports__